module.exports = __webpack_public_path__ + "daea61b3eb8efd3755afd2ba76d66999.svg";